<template>
	<div class="container">
		<div class="segmentos-header">
			<div class="segmentos-title">
				<h1>Segmentos</h1>
				<p>Aquí puedes gestionar los segmentos de venta de tu organización.</p>
			</div>
			<button class="btn" @click.prevent="showNewSegmentoModal()" v-if="orAc.Permisos.includes('CrearSegmento')"><i class='bx bx-plus'></i>Añadir segmento</button>
		</div>
		<div class="segmentos-content" v-if="!isCargandoSegmentos">

		</div>
		<clip-loader class="segmentos-loader" :loading="isCargandoSegmentos" :color="'var(--color-primary)'" :size="'52px'"></clip-loader>
	</div>
</template>

<script>
	import axios from 'axios'
	import { mapState, mapActions, mapGetters }  from 'vuex';
	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

	export default {
		data(){
			return {
				isCargandoSegmentos: true,
				segmentos: [],
			}
		},
		components: {
			ClipLoader
		},
		computed: {
			...mapState('AuthModule', ['user', 'organizadorActivo']),
			...mapGetters('AuthModule', ['orAc']),
		},
		async mounted(){
			this.isCargandoSegmentos = true
			await this.getSegmentos();
		},
		methods: {
			...mapActions('AuthModule', ['logout']),

			async getSegmentos(){
				try {
					let response = await axios.post('/WSOrgUsuarios', {
						OrganizadorId: Number(this.organizadorActivo),
						UsuarioId : this.user.UsuarioId
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });
					
					if(response.data.ErrorCod === 1){
						this.logout();
					} else {
						if(response.data.ErrorCod === 10){
							this.$store.dispatch('showError', 'Necesitas permisos para ver esta sección.')
							this.$router.push({ name: 'home' });
						} else {
							this.segmentos = response.data.SDTOrganizadorUsuarios
						}
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error, intenta nuevamente.')
					this.$router.push({ name: 'error' });
				} finally {
					this.isCargandoSegmentos = false
				}
			},
			showNewSegmentoModal(){

			}
		}
	}
</script>


<style lang="scss" scoped>
	.segmentos-loader{
		margin: 80px 0px;
	}

	.segmentos-header{
		width: 100%;
		@include flex(row, space-between, center);

		.segmentos-title{
			@include flex(column, center, flex-start);

			h1{
				margin: 0;
				font-family: var(--font-sora);
				font-size: 30px;
				line-height: 1em;
				margin-bottom: 10px;
			}

			p{
				font-size: 14px;
				font-weight: var(--fw-400);
				letter-spacing: 0.3px;
				color: var(--color-darker);
			}
		}

		.btn{
			@include flex(row, center, center);
			background-color: var(--color-darker);
			border: 1px solid var(--color-darker);
			border-radius: 8px;
			outline: none;
			padding: 0px 14px;
			color: var(--color-white);
			font-size: 13px;
			font-weight: var(--fw-500);
			font-family: var(--font-sora);
			line-height: 1.4em;
			letter-spacing: 1px;
			margin: 0px;
			height: 38px;
			@include transition(all 0.2s);
			cursor: pointer;
			@include flex(row, center, center);

			i{
				margin-right: 5px;
				font-size: 18px;
			}

			&:hover {
				background-color: var(--color-primary);
				border: 1px solid var(--color-darker);
				transform: translate(-0.25rem, -0.25rem);
				box-shadow: 0.25rem 0.25rem 0 var(--color-darker);
				color: var(--color-darker);
			}

			&:disabled {
				background-color: #e8e9eb;
				color: var(--color-darker);
				border-color: #e8e9eb;
				cursor: not-allowed;

				&:hover{
					box-shadow: none;
					transform: none;
					border-color: #e8e9eb;
				}
			}
		}
	}

	.segmentos-content{
		margin-top: 40px;
		width: 100%;
		@include flex(column, flex-start, flex-start);
	}
</style>